export default __webpack_public_path__ + "static/betql-image-right-1-3a22acae468bbce1230b4573267a23da.avif";